import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import api from "@/api/api";
import { getCookie } from "@/api/clients";
import { onMounted } from "vue";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const route = useRoute();

onMounted(async () => {
  const locale = getCookie("pi-lang");

  let ref = route.query.ref || localStorage.getItem("redirect_url");
  localStorage.removeItem("redirect_url");

  if (ref) {
    const res = await api.auth.getLoginUrl(String(ref), locale);
    return (window.location.href = res.url);
  }

  const res = await api.auth.getLoginUrl(undefined, locale);
  window.location.href = res.url;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})